var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLogoGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 8C25.908 8 8 25.908 8 48C8 70.092 25.908 88 48 88C70.092 88 88 70.092 88 48C88 25.908 70.092 8 48 8Z",
    fill: "url(#paint0_linear_0_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.414 58.602H63.766L65.392 48.086H53.414V42.338C53.414 37.97 54.842 34.096 58.928 34.096H65.494V24.92C64.34 24.764 61.9 24.424 57.29 24.424C47.662 24.424 42.018 29.508 42.018 41.092V48.088H32.12V58.604H42.016V87.508C43.976 87.8 45.962 88 48 88C49.842 88 51.64 87.832 53.414 87.592V58.602Z",
    fill: "#22223B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3",
    x1: 19.986,
    y1: 19.986,
    x2: 81.23,
    y2: 81.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoGold);
export default __webpack_public_path__ + "static/media/FacebookLogoGold.a5e6932d08d9194c7e8db46ab3fa691d.svg";
export { ForwardRef as ReactComponent };